module.exports = __webpack_public_path__ + "img/default-emoji.5eac85ce.png";